import React from 'react'
import { useSelector } from 'react-redux'

import InChatView from 'components/InChatView'
import ChatChannels from './ChatChannels'
import { CHANNELINCHAT } from 'constants/channels'

const Chat = ({ setting, getSetting }) => {
  const { tabs: { activeChannel } } = useSelector(store => store)

  if (CHANNELINCHAT.includes(activeChannel)) {
    return <InChatView />
  }

  return (
    <ChatChannels
      setting={setting}
      getSetting={getSetting}
    />
  )
}

export default Chat
